import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { waLink, WA_DEFAULT_MSG, PHONE_NUMBER_TEL } from "@/lib/site";

export default function StickyBar() {
  return (
    <motion.div
      initial={{ y: 90 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-[#060B19]/95 p-3 backdrop-blur-xl md:hidden"
      data-testid="sticky-mobile-cta-container"
    >
      <div className="flex gap-2">
        <a
          href={waLink(WA_DEFAULT_MSG)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-mobile-whatsapp-cta"
          className="flex min-h-[52px] flex-1 items-center justify-center gap-2 rounded-xl bg-[#25D366] font-bold text-[#04140a] active:scale-95"
        >
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping-slow absolute h-full w-full rounded-full bg-[#04140a]" />
            <span className="relative h-2.5 w-2.5 rounded-full bg-[#04140a]" />
          </span>
          <MessageCircle className="h-5 w-5" strokeWidth={2.5} />
          WhatsApp · 90 min
        </a>
        <a
          href={`tel:${PHONE_NUMBER_TEL}`}
          data-testid="sticky-mobile-call-cta"
          className="flex min-h-[52px] items-center justify-center gap-2 rounded-xl border border-white/15 px-5 font-bold text-white active:scale-95"
        >
          <Phone className="h-5 w-5" />
          Chiama
        </a>
      </div>
    </motion.div>
  );
}
